import styled from 'styled-components';

import {
  Select as DatePickerSelect,
  SelectLabel as DatePickerSelectLabel,
} from 'components/commons/DatePicker/styles';

import {
  colorAccent100,
  colorBlack900,
  colorGrey200,
  colorGrey400,
  colorPrimaryLighten95,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryDesktopMin,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Content = styled.div`
  width: 100%;
`;

export const Wrapper = styled.header`
  background-color: ${colorWhite};
  width: 100%;
`;

export const HeaderSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px 16px 24px;
  background: ${colorWhite};
  border-radius: 12px;

  @media ${mediaQueryMobileLargeMin} {
    gap: 24px;
    padding: 20px 24px 24px;
  }
`;

export const IntroBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    gap: 20px;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
`;

export const Title = styled.h1`
  order: 2;
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${colorBlack900};

  @media ${mediaQueryMobileLargeMin} {
    order: 1;
    font-size: 24px;
    line-height: 32px;
  }
`;

export const UpdatedSlot = styled.div`
  order: 1;
  flex-shrink: 0;
  max-width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    order: 2;
  }

  & > div {
    margin-bottom: 0;
    white-space: nowrap;
  }
`;

export const DateControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  order: 1;

  @media ${mediaQueryMobileLargeMin} {
    order: 2;
    width: auto;
    flex-shrink: 0;
  }
`;

export const CurrencyTabsSlot = styled.div`
  order: 2;
  flex-shrink: 0;

  @media ${mediaQueryMobileLargeMin} {
    order: 1;
  }
`;

export const ControlsMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
    gap: 24px;
    width: auto;
  }

  @media ${mediaQueryDesktopMin} {
    flex: 0 1 auto;
    min-width: min-content;
  }
`;

export const ControlsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${mediaQueryDesktopMin} {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px 24px;
  }
`;

export const DateSelectWrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-width: 0;

  /* Select рендериться кнопкою-тригером на десктопі й обгорткою нативного інпута на мобілці */
  ${DatePickerSelect} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 40px;
    border-radius: 4px;
    padding: 8px 11px;
    margin: 0;
    width: 100%;
    min-width: 0;
    white-space: nowrap;
    gap: 8px;
  }

  ${DatePickerSelectLabel} {
    white-space: nowrap;
    margin-left: 0;
    margin-right: 0;
    font-size: 14px;
    line-height: 24px;
    color: ${colorBlack900};
  }
`;

export const YearSelectWrapper = styled.div`
  position: relative;
  flex: 1 1 0;
  min-width: 0;

  @media ${mediaQueryMobileLargeMin} {
    flex: 0 0 101px;
    width: 101px;
  }
`;

export const SelectButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 8px 11px;
  margin: 0;
  border: 1px solid ${colorGrey200};
  border-radius: 4px;
  background: ${colorWhite};
  outline: 0;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900};
  cursor: pointer;

  & > svg {
    display: block;
    flex-shrink: 0;
    fill: ${colorBlack900};
    pointer-events: none;
    transform: ${({ $isOpen }) =>
      $isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  }

  &:hover {
    border-color: ${colorGrey400};
  }
`;

export const SelectValue = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${colorBlack900};
`;

export const SourceFilterSlot = styled.div`
  flex: 0 1 auto;
  align-self: flex-start;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  @media ${mediaQueryDesktopMin} {
    align-self: center;
    width: auto;
    margin-left: auto;
  }

  & > div {
    max-width: 100%;
  }

  & > div > button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: auto;
    max-width: 100%;
    color: ${colorAccent100};

    & > svg {
      flex-shrink: 0;
      fill: ${colorAccent100};
      margin-left: 0 !important;
    }
  }

  & > div > button > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${colorAccent100};
    padding-right: 0;
  }

  & > div > button + div {
    @media ${mediaQueryMobileLargeMin} {
      height: auto;
      max-height: 280px;
    }
  }
`;

export const YearSelectList = styled.ul`
  position: fixed;
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $left }) => `${$left}px`};
  z-index: 1000;
  box-sizing: border-box;
  width: ${({ $width }) => `${$width}px`};
  min-width: 0;
  height: ${({ $fitContent }) => ($fitContent ? 'auto' : '280px')};
  max-height: 280px;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
  background: ${colorWhite};
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.14);

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const YearSelectOption = styled.li`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  font-family: ${fontFamilyPrimary};
  font-size: 16px;
  line-height: 24px;
  color: ${colorBlack900};
  text-align: left;
  cursor: pointer;
  background: ${({ $isActive }) => ($isActive ? '#CFE9E0' : 'transparent')};

  &:hover {
    background: ${colorPrimaryLighten95};
  }
`;
